import { Linkedin, Instagram, ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-7">
            <h3 className="font-display text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[1.02]">
              Let’s squeeze
              <br />
              <span className="brand-gradient-text">your next quarter.</span>
            </h3>
            <a
              href="#contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-yellow-400 text-zinc-950 font-bold hover:bg-yellow-300 transition-all hover:-translate-y-0.5"
            >
              Start a conversation <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="lg:col-span-5 grid grid-cols-1 lg:grid-cols-2  gap-8">
            <div>
              <div className="text-xs font-mono-ui uppercase tracking-[0.2em] text-zinc-500 mb-4">
                Reach us
              </div>
              <ul className="space-y-2 text-zinc-300 text-sm">
                <li>
                  <a
                    href={`mailto:${SITE.email}`}
                    className="hover:text-yellow-300 transition"
                    data-testid="footer-email"
                  >
                    {SITE.email}
                  </a>
                </li>
                {SITE.phones.map((p) => (
                  <li key={p}>
                    <a
                      href={`tel:${p.replace(/\s/g, "")}`}
                      className="hover:text-yellow-300 transition"
                      data-testid={`footer-phone-${p.replace(/\s|\+/g, "")}`}
                    >
                      {p}
                    </a>
                  </li>
                ))}
                <li className="text-zinc-500">{SITE.website}</li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-mono-ui uppercase tracking-[0.2em] text-zinc-500 mb-4">
                Follow
              </div>
              <ul className="space-y-3 text-zinc-300 text-sm">
                <li>
                  <a
                    href={SITE.socials.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-linkedin"
                    className="inline-flex items-center gap-2 hover:text-yellow-300 transition"
                  >
                    <Linkedin size={16} /> LinkedIn
                  </a>
                </li>
                <li>
                  <a
                    href={SITE.socials.instagram}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-instagram"
                    className="inline-flex items-center gap-2 hover:text-yellow-300 transition"
                  >
                    <Instagram size={16} /> Instagram
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pt-8 border-t border-white/10">
          <div className="flex items-center gap-3">
            <img
              src={SITE.logo}
              alt="Lemonsqueezy Marketing Labs"
              className="h-16 sm:h-20 w-auto"
            />
          </div>
          <div className="text-xs text-zinc-500 font-mono-ui">
            © {new Date().getFullYear()} Lemonsqueezy Marketing Labs · zesty solutions. seamless tech.
          </div>
        </div>
      </div>
    </footer>
  );
}
